import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as r, normalizeClass as s, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const l = {
  name: "DtIconZendesk",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  d: "M11.238 19.156V8.002L2 19.156h9.238ZM9.885 7.266A4.62 4.62 0 0 0 11.238 4H2a4.62 4.62 0 0 0 7.885 3.266Zm4.228 8.624a4.619 4.619 0 0 0-1.353 3.267h9.238a4.619 4.619 0 0 0-7.885-3.267ZM12.76 4v11.153L22 4h-9.24Z",
  fill: "#00A656"
}, null, -1), m = [
  _
];
function h(a, u, i, f, p, e) {
  return r(), d("svg", {
    "aria-label": i.ariaLabel,
    class: s([e.iconSizeClass, "d-icon d-icon--zendesk"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Zendesk",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const k = /* @__PURE__ */ o(l, [["render", h]]);
export {
  k as default
};
//# sourceMappingURL=zendesk.js.map
